import * as React from "react";
import { MetricsSideMenuContainer } from "../";
import { MetricViewContainer } from "../../../AnalyticsMetric";
import { Layout } from "antd";
import { MetricsContainerProps } from "./container";
import "./style.scss";
const { Content, Header, Sider } = Layout;

export class MetricsContainer extends React.Component<
  MetricsContainerProps,
  {}
> {
  render() {
    return (
      <div className="metrics-container">
        <Layout>
          <Sider>
            <MetricsSideMenuContainer />
          </Sider>
          <Content>
            {this.props.metrics_container_tab ? (
              <MetricViewContainer />
            ) : (
              <div>No tab selected</div>
            )}
          </Content>
        </Layout>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/modules/Analytics/components/MetricsContainer/component.tsx